var _linearGradient, _path, _linearGradient2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastodon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "96px",
    height: "96px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "V0A2Lt5ypwfiv6i4E9XwXa",
    x1: 31.993,
    x2: 31.993,
    y1: 5,
    y2: 59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#V0A2Lt5ypwfiv6i4E9XwXa)",
    d: "M28.677,59c-7.276,0-13.964-3.835-17.455-10.009c-4.632-8.193-4.24-17.641-4.221-18.039L7,20 c0-8.271,6.729-15,15-15h20c8.271,0,15,6.729,15,15v11c0,8.271-6.729,15-15,15H25.621c1.741,2.931,4.549,4.374,8.716,4.513 c3.543,0.094,7.236-1.417,7.272-1.434L43,48.491l0,7.127l-0.553,0.276C38.152,58.042,33.905,59,28.677,59z M22,7 C14.832,7,9,12.832,9,20v11c-0.005,0.139-0.377,9.329,3.963,17.007C16.1,53.554,22.121,57,28.677,57 c4.741,0,8.465-0.789,12.323-2.625v-2.947c-1.529,0.498-4.117,1.083-6.729,1.083C24.603,52.511,22.489,44,22.489,44H42 c7.168,0,13-5.832,13-13V20c0-7.168-5.832-13-13-13H22z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "V0A2Lt5ypwfiv6i4E9XwXb",
    x1: 31.995,
    x2: 31.995,
    y1: 9,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#V0A2Lt5ypwfiv6i4E9XwXb)",
    d: "M42,9H22c-6.065,0-11,4.935-11,11v11l0,0.04l-0.002,0.039 c-0.014,0.359-0.297,8.863,3.706,15.943C17.487,51.943,22.841,55,28.677,55c2.052,0,3.887-0.154,5.618-0.487 c-0.031-0.001-0.061-0.002-0.091-0.003c-6.342-0.21-10.48-3.182-13.175-8.414C19.904,43.912,19.466,42,19.466,42h3.023H42 c6.065,0,11-4.935,11-11V20C53,13.935,48.065,9,42,9z M47,36h-6V23c0-1.654-1.346-3-3-3s-4,1.346-4,3v2v7h-4h-1v-9 c0-1.654-1.346-3-3-3s-3,1.346-3,3v13h-6V23c0-4.963,4.038-9,9-9c2.57,0,4.617,1.624,6,3.874C33.383,15.624,35.43,14,38,14 c4.962,0,9,4.037,9,9V36z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastodon);
export default __webpack_public_path__ + "static/media/mastodon.d7059a354ade0ea4b00e5f688f5bf5c9.svg";
export { ForwardRef as ReactComponent };